import { gql, useQuery } from '@apollo/client';

const QUERY = gql`
  query {
    users {
      id
      email
      isActive
      role {
        id
        name
      }
    }
  }
`;

export const useGetUsersQuery = () => useQuery(QUERY);
